import axiosInstance from './AxiosInstance';

class EditApplicationService {
    constructor() {
        this.endpoint = "/api"
    }

    async editApplication(id,data) {
        try {
            const response = await axiosInstance.put(`${this.endpoint}/applications/${id}`,data);
            return response.data;
        } catch (error) {
            return { status: false, "message": 'Ooops, The is a technical problem,Please Try Again' }
        }
    }
    async editCorrection(data) {
        try {
            const response = await axiosInstance.put(`${this.endpoint}/applications/correction`,data);
            return response.data;
        } catch (error) {
            return { status: false, "message": 'Ooops, The is a technical problem,Please Try Again' }
        }
    }


}

const editApplicationService = new EditApplicationService();

export { editApplicationService };